import { IUser, IUser_Group } from "bets.oddprovider.lib.common.ts/models"
import { ApiClientUtils } from 'fwork-jsts-common/src/apiClient'
import { FormItemStyled, FormStyled } from 'fwork.react.apptemplate'
import { useSnackbar } from 'notistack'
import React, { useState } from 'react'
import { FaTrash } from 'react-icons/fa'
import axios from "../../apiClient/axios"
import { UsersApiClient } from '../../apiClient/users'
import { DEFAULTGAP } from '../../globals'
import { DropDownSearchComponent } from '../common/dropDownSearch'
import { HeaderComponent } from '../common/header'

export const UserGroupUsersComponent = (props: {
  data?: IUser_Group[],
  onSelectItem?: ((item: IUser_Group, user: IUser) => void) | undefined,
  onDelete?: (item: IUser_Group) => void,
  onAdd?: () => void
}) => {
  const { enqueueSnackbar } = useSnackbar()

  const [gettingUsers, setGettingUsers] = useState<boolean>()
  const getUsers = async (filter: string) => {
    if (gettingUsers) return
    setGettingUsers(true)
    try {
      const response = await new UsersApiClient(axios).get({
        where: {
          name: { $regex: filter, $options: 'i' }
        },
        sort: { name: 1 }
      })
      return response.data?.payload
    } catch (error) {
      enqueueSnackbar(ApiClientUtils.getErrorMessage(error), { variant: 'error' })
    } finally {
      setGettingUsers(false)
    }
  }

  return <div style={{
    paddingTop: DEFAULTGAP
  }}>
    <HeaderComponent
      title=''
      onAddClick={props.onAdd}
    />
    <FormStyled>
      {props.data?.map((u_g, idx) => <FormItemStyled key={idx} gap={DEFAULTGAP}
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          rowGap: DEFAULTGAP,
          columnGap: DEFAULTGAP,
        }}>
        <DropDownSearchComponent
          initInputValue={u_g.user?.name || ''}
          progress={gettingUsers}
          style={{ width: '100%' }}
          label="Usuário"
          modelLabelName="name"
          dataBuilder={async (typedText: string | undefined) => {
            if (typedText)
              return await getUsers(typedText)
          }}
          onSelectItem={(user: IUser) => {
            if (props.onSelectItem)
              props.onSelectItem(u_g, user)
          }}
        />
        <FaTrash style={{ cursor: 'pointer', }} color='grey' size={20} onClick={() => {
          if (props.onDelete)
            props.onDelete(u_g)
        }} />
      </FormItemStyled>)}
    </FormStyled>
  </div>
}